import qatarFlag from "../assets/flag/qatar.png";
import ecuadorFlag from "../assets/flag/ecuador.png";
import senegalFlag from "../assets/flag/senegal.png";
import paisesBajosFlag from "../assets/flag/paises-bajos.png";
import inglaterraFlag from "../assets/flag/inglaterra.png";
import iranFlag from "../assets/flag/iran.png";
import estadosUnidosFlag from "../assets/flag/estados-unidos.png";
import galesFlag from "../assets/flag/gales.png";
import argentinaFlag from "../assets/flag/argentina.png";
import arabiaSauditaFlag from "../assets/flag/arabia-saudita.png";
import mexicoFlag from "../assets/flag/mexico.png";
import poloniaFlag from "../assets/flag/polonia.png";
import dinamarcaFlag from "../assets/flag/dinamarca.png";
import tunezFlag from "../assets/flag/tunez.png";
import franciaFlag from "../assets/flag/francia.png";
import australiaFlag from "../assets/flag/australia.png";
import alemaniaFlag from "../assets/flag/alemania.png";
import japonFlag from "../assets/flag/japon.png";
import espanaFlag from "../assets/flag/espana.png";
import costaRicaFlag from "../assets/flag/costa-rica.png";
import marruecosFlag from "../assets/flag/marruecos.png";
import croaciaFlag from "../assets/flag/croacia.png";
import belgicaFlag from "../assets/flag/belgica.png";
import canadaFlag from "../assets/flag/canada.png";
import suizaFlag from "../assets/flag/suiza.png";
import camerunFlag from "../assets/flag/camerun.png";
import brasilFlag from "../assets/flag/brasil.png";
import serbiaFlag from "../assets/flag/serbia.png";
import uruguayFlag from "../assets/flag/uruguay.png";
import coreaDelSurFlag from "../assets/flag/corea-del-sur.png";
import portugalFlag from "../assets/flag/portugal.png";
import ghanaFlag from "../assets/flag/ghana.png";

export const getFlagUrl = (flagName) => {
  let flagUrl = "";
  switch (flagName) {
    case "Qatar":
      flagUrl = qatarFlag;
      break;
    case "Ecuador":
      flagUrl = ecuadorFlag;
      break;
    case "Senegal":
      flagUrl = senegalFlag;
      break;
    case "Países Bajos":
      flagUrl = paisesBajosFlag;
      break;
    case "Inglaterra":
      flagUrl = inglaterraFlag;
      break;
    case "Irán":
      flagUrl = iranFlag;
      break;
    case "Estados Unidos":
      flagUrl = estadosUnidosFlag;
      break;
    case "Gales":
      flagUrl = galesFlag;
      break;
    case "Argentina":
      flagUrl = argentinaFlag;
      break;
    case "Arabia Saudita":
      flagUrl = arabiaSauditaFlag;
      break;
    case "México":
      flagUrl = mexicoFlag;
      break;
    case "Polonia":
      flagUrl = poloniaFlag;
      break;
    case "Dinamarca":
      flagUrl = dinamarcaFlag;
      break;
    case "Túnez":
      flagUrl = tunezFlag;
      break;
    case "Francia":
      flagUrl = franciaFlag;
      break;
    case "Australia":
      flagUrl = australiaFlag;
      break;
    case "Alemania":
      flagUrl = alemaniaFlag;
      break;
    case "Japón":
      flagUrl = japonFlag;
      break;
    case "España":
      flagUrl = espanaFlag;
      break;
    case "Costa Rica":
      flagUrl = costaRicaFlag;
      break;
    case "Marruecos":
      flagUrl = marruecosFlag;
      break;
    case "Croacia":
      flagUrl = croaciaFlag;
      break;
    case "Bélgica":
      flagUrl = belgicaFlag;
      break;
    case "Canadá":
      flagUrl = canadaFlag;
      break;
    case "Suiza":
      flagUrl = suizaFlag;
      break;
    case "Camerún":
      flagUrl = camerunFlag;
      break;
    case "Brasil":
      flagUrl = brasilFlag;
      break;
    case "Serbia":
      flagUrl = serbiaFlag;
      break;
    case "Uruguay":
      flagUrl = uruguayFlag;
      break;
    case "Corea del Sur":
      flagUrl = coreaDelSurFlag;
      break;
    case "Portugal":
      flagUrl = portugalFlag;
      break;
    case "Ghana":
      flagUrl = ghanaFlag;
      break;
    default:
      flagUrl = uruguayFlag;
  }
  return flagUrl;
};

export const getVideoFlagUrl = (flagName) => {
  let flagUrl = "";
  switch (flagName) {
    case "Qatar":
      flagUrl =
        "https://multimedia.mag.elcomercio.pe/calculadora-campeon-qatar-2022/videos/qatar.mp4";
      break;
    case "Ecuador":
      flagUrl =
        "https://multimedia.mag.elcomercio.pe/calculadora-campeon-qatar-2022/videos/ecuador.mp4";
      break;
    case "Senegal":
      flagUrl =
        "https://multimedia.mag.elcomercio.pe/calculadora-campeon-qatar-2022/videos/senegal.mp4";
      break;
    case "Países Bajos":
      flagUrl =
        "https://multimedia.mag.elcomercio.pe/calculadora-campeon-qatar-2022/videos/paises-bajos.mp4";
      break;
    case "Inglaterra":
      flagUrl =
        "https://multimedia.mag.elcomercio.pe/calculadora-campeon-qatar-2022/videos/inglaterra.mp4";
      break;
    case "Irán":
      flagUrl =
        "https://multimedia.mag.elcomercio.pe/calculadora-campeon-qatar-2022/videos/iran.mp4";
      break;
    case "Estados Unidos":
      flagUrl =
        "https://multimedia.mag.elcomercio.pe/calculadora-campeon-qatar-2022/videos/estados-unidos.mp4";
      break;
    case "Gales":
      flagUrl =
        "https://multimedia.mag.elcomercio.pe/calculadora-campeon-qatar-2022/videos/gales.jpg";
      break;
    case "Argentina":
      flagUrl =
        "https://multimedia.mag.elcomercio.pe/calculadora-campeon-qatar-2022/videos/argentina.mp4";
      break;
    case "Arabia Saudita":
      flagUrl =
        "https://multimedia.mag.elcomercio.pe/calculadora-campeon-qatar-2022/videos/arabia-saudita.mp4";
      break;
    case "México":
      flagUrl =
        "https://multimedia.mag.elcomercio.pe/calculadora-campeon-qatar-2022/videos/mexico.mp4";
      break;
    case "Polonia":
      flagUrl =
        "https://multimedia.mag.elcomercio.pe/calculadora-campeon-qatar-2022/videos/polonia.mp4";
      break;
    case "Dinamarca":
      flagUrl =
        "https://multimedia.mag.elcomercio.pe/calculadora-campeon-qatar-2022/videos/dinamarca.mp4";
      break;
    case "Túnez":
      flagUrl =
        "https://multimedia.mag.elcomercio.pe/calculadora-campeon-qatar-2022/videos/tunez.mp4";
      break;
    case "Francia":
      flagUrl =
        "https://multimedia.mag.elcomercio.pe/calculadora-campeon-qatar-2022/videos/francia.mp4";
      break;
    case "Australia":
      flagUrl =
        "https://multimedia.mag.elcomercio.pe/calculadora-campeon-qatar-2022/videos/australia.jpg";
      break;
    case "Alemania":
      flagUrl =
        "https://multimedia.mag.elcomercio.pe/calculadora-campeon-qatar-2022/videos/alemania.mp4";
      break;
    case "Japón":
      flagUrl =
        "https://multimedia.mag.elcomercio.pe/calculadora-campeon-qatar-2022/videos/japon.mp4";
      break;
    case "España":
      flagUrl =
        "https://multimedia.mag.elcomercio.pe/calculadora-campeon-qatar-2022/videos/espana.mp4";
      break;
    case "Costa Rica":
      flagUrl =
        "https://multimedia.mag.elcomercio.pe/calculadora-campeon-qatar-2022/videos/costa-rica.jpg";
      break;
    case "Marruecos":
      flagUrl =
        "https://multimedia.mag.elcomercio.pe/calculadora-campeon-qatar-2022/videos/marruecos.mp4";
      break;
    case "Croacia":
      flagUrl =
        "https://multimedia.mag.elcomercio.pe/calculadora-campeon-qatar-2022/videos/croacia.mp4";
      break;
    case "Bélgica":
      flagUrl =
        "https://multimedia.mag.elcomercio.pe/calculadora-campeon-qatar-2022/videos/belgica.mp4";
      break;
    case "Canadá":
      flagUrl =
        "https://multimedia.mag.elcomercio.pe/calculadora-campeon-qatar-2022/videos/canada.mp4";
      break;
    case "Suiza":
      flagUrl =
        "https://multimedia.mag.elcomercio.pe/calculadora-campeon-qatar-2022/videos/suiza.mp4";
      break;
    case "Camerún":
      flagUrl =
        "https://multimedia.mag.elcomercio.pe/calculadora-campeon-qatar-2022/videos/camerun.mp4";
      break;
    case "Brasil":
      flagUrl =
        "https://multimedia.mag.elcomercio.pe/calculadora-campeon-qatar-2022/videos/brasil.mp4";
      break;
    case "Serbia":
      flagUrl =
        "https://multimedia.mag.elcomercio.pe/calculadora-campeon-qatar-2022/videos/serbia.mp4";
      break;
    case "Uruguay":
      flagUrl =
        "https://multimedia.mag.elcomercio.pe/calculadora-campeon-qatar-2022/videos/uruguay.mp4";
      break;
    case "Corea del Sur":
      flagUrl =
        "https://multimedia.mag.elcomercio.pe/calculadora-campeon-qatar-2022/videos/corea-del-sur.mp4";
      break;
    case "Portugal":
      flagUrl =
        "https://multimedia.mag.elcomercio.pe/calculadora-campeon-qatar-2022/videos/portugal.mp4";
      break;
    case "Ghana":
      flagUrl =
        "https://multimedia.mag.elcomercio.pe/calculadora-campeon-qatar-2022/videos/ghana.mp4";
      break;
    default:
      flagUrl =
        "https://multimedia.mag.elcomercio.pe/calculadora-campeon-qatar-2022/videos/uruguay.mp4";
  }
  return flagUrl;
};
